export const INTEGRATION_FEATURE_KEY = 'integration';
